"use strict";

$(() => {

    $('[data-toggle="tooltip"]').tooltip();

    $('[data-toggle="popover"]').popover({
        trigger: 'focus',
        delay: {show: 0, hide: 100} // Delay hiding the popover just long enough so clicking a link in the popover still triggers/opens before it closes
    });
});
